// Vet student program (free access codes). Paused: hides every way to join it.
// Existing student plans keep working until they expire.
export const STUDENT_PROGRAM = false;
